import styled, { css } from "styled-components";
import { colors } from "../../../../styled/varibles";

export const PaginationSC = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0px;
    gap: 1.4rem;
`;

export const ButtonSC = styled.div<{ isActive: boolean }>`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 2.8rem;
    height: 2.8rem;
    border: 1px solid ${colors.textColor};
    border-radius: 5rem;
    background: ${({ isActive }) => (isActive ? colors.textColor : colors.white)};
    
    ${({ isActive }) =>
        isActive &&
        css`
            & ${ButtonText} {
                color: ${colors.white};
            }
        `}}
`;

export const ButtonText = styled.span`
    font-family: "Inter";
    font-style: normal;
    font-weight: 700;
    font-size: 1.6rem;
    line-height: 160%;
    text-align: center;
    letter-spacing: -0.01em;
    color: ${colors.textColor};
`;

export const DotsSC = styled.div`
    display: flex;
    gap: 0.7rem;
`;
export const DotSC = styled.div`
    width: 4px;
    height: 4px;
    background: ${colors.textColor};
`;
